































































































import Vue from 'vue'
import Component from 'vue-class-component'
import Icon from './Icon.vue'
import ScrollView from './ScrollView.vue'
import { EActivityStatus, IActivity } from '@zunta/configurations'
import { User } from '@/classes/User'
import Api from '@/api'
import { VPopover } from 'v-tooltip'

const moment: any = require('moment')
const countdown: any = require('moment-countdown')

@Component({
  components: {
    Icon,
    ScrollView,
    VPopover
  }
})
export default class ActivityMessages extends Vue {
  EActivityStatus: any = EActivityStatus
  user: User = Api.getUser() as User
  activities: IActivity[] = []

  get isSomeError () {
    return !!this.activities.find((activity: IActivity) => activity.status === EActivityStatus.ERROR)
  }

  get isAllCompleted () {
    return this.activities.length !== 0 && this.activities.length === this.activities.filter((activity: IActivity) => activity.status === EActivityStatus.SUCCESS).length
  }

  get isSomeActivityInProcess () {
    return !!this.activities.find((activity: IActivity) => activity.status === EActivityStatus.PENDING)
  }

  getActivitySubMessage (activity: IActivity) {
    if (activity.status === EActivityStatus.ERROR) {
      return `[${activity.error}] ${activity.options.facilityName || `${activity.options.depositId ? `Deposit #${activity.options.depositId}` : 'Something Went Wrong'}`} - ${new Date(activity.updatedAt).toLocaleDateString()}`
    }
    switch (activity.name) {
      case 'Facilities Importing':
        return `${activity.options.facilities.length} ${activity.options.facilities.length > 1 ? 'Facilities are' : 'Facility is'} being imported (2-5 Minutes)`
      case 'Facilities Imported':
        return `${activity.options.facilities ? activity.options.facilities.length : 0} ${activity.options.facilities && activity.options.facilities.length > 1 ? 'Facilities' : 'Facility'} successfully imported!`
      case 'Importing statements':
      case 'Updating statements':
      case 'Updating Facility':
      case 'Facility updating':
        return ` ${activity.options.facilityName} resident and transaction information updating`
      case 'Statements generating': // text changed from: case 'Fetch Facility Statements':
      case 'Statements updating': // text changed from 'Fetch Facility Statements':
        return `${activity.options.facilityName}`
      case 'Residents Imported':
      case 'Import Residents':
        return `${activity.options.facilityName}`
      case 'Push Payments To PCC':
        return `${activity.options.depositId} Payments Deposit With ${new Date(activity.options.effectiveDate).toLocaleDateString()} Effective Date`
      case 'Payment Pushed to PCC':
        return `Deposit #${activity.options.depositId} was pushed to PCC.`
      case 'Statements imported':
      case 'Statement imported':
      case 'Statement generated':
      case 'Statement successfully generated':
      case 'Updating transactions':
      case 'Transactions updated':
      case 'Facility Updated':
      case 'Facility successfully updated':
        return `${activity.options.facilityName} resident and transaction information updated`
      case 'Fetch Facility Transactions':
        return `${activity.options.facilityName} - ${new Date(activity.updatedAt).toLocaleDateString()}`
      case 'Facility failed to update':
        return `${activity.options.facilityName}`
      case 'Mailing Statements In Process':
      case 'Mail Statements has been completed':
        return `${activity.options.batchName}`
      default:
        return activity && activity.options && activity.options.facilityName ? activity.options.facilityName : ''
    }
  }

  addActivity (activity: IActivity) {
    const facilityId = activity.options.facilityId || activity.options.id
    const user = this.user.data
    if (!user.isAllFacilities && facilityId && user.facilities && !user.facilities.includes(facilityId)) {
      return
    }

    const a = this.activities.find((existActivity: IActivity) => existActivity.id === activity.id)
    if (a) {
      for (let key in activity) {
        (a as any)[key] = (activity as any)[key]
      }
      if (a.status === EActivityStatus.DELETED) {
        this.activities = this.activities.filter(act => act.id !== a.id)
        return
      }
      if ((
        a.name === 'Statement generated' ||
        a.name === 'Statement successfully generated' ||
        a.name === 'Chain successfully updated' ||
        a.name === 'Facility successfully updated' ||
        a.name === 'Fetch Facility Statements'
      ) && a.status === EActivityStatus.SUCCESS) {
        this.checkMailingForReload()
      }
      if ((a.name === 'Facilities Imported' || a.name === 'Facility successfully updated') && a.status === EActivityStatus.SUCCESS) {
        this.checkFacilitiesForReload().then(() => {})
      }
    } else if (activity.status !== EActivityStatus.DELETED) {
      this.activities.unshift(activity)
    }
    this.updateTooltip()
  }

  updateTooltip () {
    this.$nextTick(() => this.$forceUpdate())
  }

  addManyActivity (activities: IActivity[]) {
    activities.slice().reverse().forEach(this.addActivity)
  }

  getTimestampLabel (date: Date | string) {
    const timeline = moment(date).countdown(countdown.DAYS, NaN, 1).toString()
    return timeline ? `${timeline} ago` : 'Just Now'
  }

  formatAMPM (dateStr: Date | string) {
    return moment(dateStr).format('hh:mm A')
  }

  mounted () {
    this.getActivities()
    this.$eventBus.$on('activity', this.addActivity)
    this.$eventBus.$on('activities', this.addManyActivity)
  }

  getActivities () {
    this.$socketManager.send('getActivities')
  }

  beforeDestroy () {
    this.$eventBus.$off('activity', this.addActivity)
    this.$eventBus.$off('activities', this.addManyActivity)
  }

  checkMailingForReload () {
    if (this.$route.name === 'management-mailings') {
      this.$eventBus.$emit('reload-batch-list')
      // window.location.reload()
    }
  }

  async checkFacilitiesForReload () {
    if (this.$route.name === 'management-facilities') {
      await Api.getInstance().refreshToken()
      this.$eventBus.$emit('reload-facility-list')
      // window.location.reload()
    }
  }
}
